import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Empty } from 'vant'
  import { computed, toRefs } from 'vue'

  
export default /*#__PURE__*/_defineComponent({
  props: {
    type: {
      type: String,
      default: 'error'
    },
    image: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  setup(__props) {

const props = __props

  
  const { type, image } = toRefs(props)

  const showImage = computed(() => {
    if (image.value) {
      return image.value
    } else if (type.value == 'error') {
      return require('@/assets/images/empty-error/icon-error.png')
    } else if (type.value == 'empty') {
      return require('@/assets/images/empty-error/icon-empty.png')
    } else {
      return ''
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Empty), {
    image: _unref(showImage),
    "image-size": 120,
    description: __props.text
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["image", "description"]))
}
}

})